"use client";

import React from "react";
import { toggle } from "./toggle";

type Props = JSX.IntrinsicElements["button"];

export const ToggleButton = ({ children, onClick, ...props }: Props) => (
  <button
    type="button"
    onClick={(e) => {
      toggle(e.currentTarget);
      onClick?.(e);
    }}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  >
    {children}
  </button>
);
